import { render, staticRenderFns } from "./SettingsSms.vue?vue&type=template&id=51d78506&scoped=true&"
import script from "./SettingsSms.vue?vue&type=script&lang=js&"
export * from "./SettingsSms.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSms.vue?vue&type=style&index=0&id=51d78506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d78506",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/SettingsSms.vue
// module id = null
// module chunks = 